import { useSelector } from "react-redux";
import Layout from "../../components/global/layout";
import { IoHandRightOutline } from "react-icons/io5";

const Dashboard = () => {
  const user = useSelector((state: any) => state.user)

  return (
    <>
      <Layout>
        <h4 className="text-2xl font-bold mb-3 flex items-center gap-2 capitalize">
          <IoHandRightOutline className="text-3xl slow-shake text-[#130264]" />
          <span className="">Hi,</span> {user?.fullName}
        </h4>
      </Layout>
    </>
  );
};

export default Dashboard;
